import { config } from '@/helpers';

const NAVIGATION_INTENT_KEY = 'fulfillment_navigation_intent';
const DELIVERY_RESTORE_KEY = 'fulfillment_delivery_restore';

export const storeNavigationIntent = (intent) => {
	if (typeof window === 'undefined' || !intent) return;
	sessionStorage.setItem(NAVIGATION_INTENT_KEY, intent);
};

export const readNavigationIntent = () => {
	if (typeof window === 'undefined') return null;
	return sessionStorage.getItem(NAVIGATION_INTENT_KEY);
};

export const clearNavigationIntent = () => {
	if (typeof window === 'undefined') return;
	sessionStorage.removeItem(NAVIGATION_INTENT_KEY);
};

export const markFulfillmentRestorePending = (data = {}) => {
	if (typeof window === 'undefined') return;
	sessionStorage.setItem(DELIVERY_RESTORE_KEY, JSON.stringify(data));
};

export const readFulfillmentRestorePending = () => {
	if (typeof window === 'undefined') return null;
	try {
		const raw = sessionStorage.getItem(DELIVERY_RESTORE_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
};

export const consumeFulfillmentRestorePending = () => {
	const data = readFulfillmentRestorePending();
	if (typeof window !== 'undefined') {
		sessionStorage.removeItem(DELIVERY_RESTORE_KEY);
	}
	return data;
};

export const resolveNavigationIntent = (redirectAfterConfirm) => {
	const stored = readNavigationIntent();
	if (stored === 'cart' || stored === 'checkout') return stored;
	if (redirectAfterConfirm === 'cart' || redirectAfterConfirm === 'checkout') return redirectAfterConfirm;
	if (redirectAfterConfirm === true || redirectAfterConfirm === 'menu') return 'menu';
	return stored || redirectAfterConfirm || null;
};

export const getNavigationIntent = (url) => {
	const path = typeof url === 'object' ? url?.pathname || '' : url || '';
	if (path.includes('/checkout/')) return 'checkout';
	if (path.includes('/cart/')) return 'cart';
	return false;
};

export const resolveRedirectRouteKey = (redirectAfterConfirm) => {
	if (!redirectAfterConfirm) return null;
	if (redirectAfterConfirm === 'cart') return 'cart';
	if (redirectAfterConfirm === 'checkout') return 'checkout';
	return 'menu';
};

export const resolveRedirectPath = (redirectAfterConfirm) => {
	const routeKey = resolveRedirectRouteKey(redirectAfterConfirm);
	if (!routeKey) return null;
	return config.routes[routeKey]?.path || null;
};
